<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Fixed Asset - Form 
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="7" >
                <b-row >
                  <b-col lg="5" >
                    <b-input-group >
                        <b-input-group-prepend><label>Fixed Asset Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Reference Doc.#</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomorpo" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-input-group >
                    <b-input-group-prepend><label>Fixed Asset Name</label></b-input-group-prepend>
                    <b-form-input v-model="model.asdesc" :state="!$v.model.asdesc.$error"></b-form-input>
                </b-input-group>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial" placeholder="Serial Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Original Cost</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <b-form-select class="input-group-text" :disabled="(model.Penyusutan >0 )" v-model="model.matauang" :plain="true" :options="currency" ></b-form-select>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," :disabled="(model.Penyusutan >0 )" v-model="model.origincost" :precision="2" :state="!$v.model.origincost.$error"></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Exch. Rate {{model.matauang}}</label></b-input-group-prepend>
                        <b-input-group-prepend> <span class="input-group-text" style="width:80px !important;">{{uanguser}}</span></b-input-group-prepend>
                        <my-number :disabled="((model.matauang === uanguser) || (model.Penyusutan >0 ))" class="form-control text-right" separator="," v-model="model.kurstrx" ></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Original Cost (LCY)</label></b-input-group-prepend>
                        <b-input-group-prepend> <span class="input-group-text" style="width:80px !important;">{{uanguser}}</span></b-input-group-prepend>
                      <my-number class="form-control text-right" disabled separator="," v-model="model.aspurcpri" :precision="2" :state="!$v.model.aspurcpri.$error"></my-number>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input :disabled="(model.Penyusutan >0 )" v-model="model.asdatacq" type="date" :state="!$v.model.asdatacq.$error"></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Child/sub Asset</label></b-input-group-prepend>
                    <b-form-input v-model="model.childs" disabled></b-form-input>
                </b-input-group>

          </b-col>
          <b-col lg="5">
                <v-dim :model="model" :key="updateDimHdr"></v-dim>              
                <b-row no-gutters>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>User of Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asuser" placeholder="usage remark"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group >
                        <b-form-input readonly v-model="model.crewinfo" ></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCrewShow=true" :disabled="((model.Penyusutan>0) || (model.aspublic==1))" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Location of Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.aslocat" placeholder="location remark"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group >
                        <b-form-input readonly v-model="model.lokasiinfo"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuAssetlocatShow=true" :disabled="((model.asetkey || '') !== '')">
                        <!-- <b-btn text="Button" @click="lkuAssetlocatShow=true"> -->
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
          </b-col>
      </b-row>
      <hr>
      <b-row>
         <b-col xl="6">
                <b-row>
                  <b-col xl="10" >
                      <b-input-group >
                          <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-select :disabled="(model.Penyusutan >0 )" v-model="model.catgid" :plain="true" :options="categories" :state="!$v.model.catgid.$error"></b-form-select>
                      </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="8" >
                    <b-input-group >
                        <b-input-group-prepend><label >Depreciation Periode</label> </b-input-group-prepend>
                        <b-form-input :disabled="(model.Penyusutan >0 )" v-model="model.lamathn" type="number" @change="update_monthly_amortisasi" :state="!$v.model.lamathn.$error"></b-form-input>
                        <b-input-group-append><span class="pt-1 pr-2" style="background-color: #f0f3f5;border: 1px solid #e4e7ea;">years</span></b-input-group-append>
                        <b-form-input  :disabled="(model.Penyusutan >0 )" v-model="model.lamabln" type="number" @change="update_monthly_amortisasi" :state="!$v.model.lamabln.$error" class="ml-2"></b-form-input>
                        <b-input-group-append><span class="pt-1 pr-1" style="background-color: #f0f3f5;border: 1px solid #e4e7ea;">months</span></b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="11" >
                    <b-input-group >
                        <b-input-group-prepend><label>Depreciation Method</label></b-input-group-prepend>
                        <b-form-radio-group  v-model="model.deprmethod" :state="!$v.model.deprmethod.$error" name="radioMethod" class="pt-1">
                            <b-form-radio :value="1">Straight</b-form-radio>
                            <b-form-radio :value="0">Double Decline(DD)</b-form-radio>
                        </b-form-radio-group> 
                        <b-input-group-prepend><span class="pt-2" style="font-size:smaller;">Tarif DD.</span></b-input-group-prepend>
                        <b-form-input v-model="model.tarifDD" type="number"  :state="!$v.model.tarifDD.$error" :disabled="(model.deprmethod==1)"></b-form-input>
                        <b-input-group-append><span class="input-group-text" style="font-size:smaller;"><i class="fa fa-percent"></i>&nbsp;per year</span></b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="11" >
                  <b-input-group >
                      <b-input-group-prepend><label>Start Depreciation</label></b-input-group-prepend>
                      <b-form-input :disabled="(model.Penyusutan >0 )" v-model="model.asdatuse" type="date" @change="update_monthly_amortisasi" :state="!$v.model.asdatuse.$error" ></b-form-input>                                        
                      <b-input-group-prepend><span class="input-group-text">finish</span></b-input-group-prepend>
                      <b-form-input v-model="model.tglAkhirDepr" type="date" disabled></b-form-input>                                        
                  </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="10" >
                    <b-input-group >
                        <b-input-group-prepend><label>Total will Depreciated</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," :disabled="(model.Penyusutan >0 )" v-model="model.totalakan" :precision="2" :state="!$v.model.totalakan.$error"></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row v-if="(model.deprmethod==1)">
                  <b-col xl="10" >
                    <b-input-group >
                        <b-input-group-prepend><label>Monthly Depreciated</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," :disabled="(model.Penyusutan >0 )" v-model="model.Nilaisusut" :precision="2" :state="!$v.model.Nilaisusut.$error"></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
                <hr>
                <b-row>
                  <b-col xl="10" >
                    <b-input-group >
                        <b-input-group-prepend><label>Accum. Depreciation</label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," v-model="model.Penyusutan" :precision="2"  disabled></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xl="10" >
                    <b-input-group >
                        <b-input-group-prepend><label>Net Value Fixed Asset </label></b-input-group-prepend>
                        <b-input-group-prepend>
                          <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
                        </b-input-group-prepend>
                      <my-number class="form-control text-right" separator="," v-model="model.NilaiNett" :precision="2" readonly></my-number>
                    </b-input-group>
                  </b-col>
                </b-row>
         </b-col>
         <b-col xl="6">
              <b-table
                class="mb-0"
                ref="table"
                outlined responsive hover small
                style="font-size:smaller;" 
                :items="amortzHist.items"
                :fields="amortzHist.fields"
                :current-page="amortzHist.page"
                :per-page="amortzHist.limit"
                :sort-by.sync="amortzHist.sortBy"
                :sort-desc.sync="amortzHist.sortDesc" 
                :key="amortzHist.page"

              >
                <template v-slot:cell(tgldeprec)="data">
                  {{data.item.tgldeprec | moment('D-MMM-YY')}}
                </template>
                <template v-slot:cell(depamount)="data">
                  {{data.item.depamount|numFormat('0,0.00')}}
                </template>
                <template v-slot:cell(depaccum)="data">
                  {{data.item.depaccum|numFormat('0,0.00')}}
                </template>
                <template v-slot:cell(tgl_gl)="data">
                  <span v-if="(data.item.tgl_gl)">{{data.item.tgl_gl | moment('D-MMM-YY')}}</span>
                </template>
              </b-table>
            <b-row>
              <b-col cols="4">
                <div class="pt-2">
                  Showing {{(amortzHist.page - 1) * amortzHist.limit + 1}}
                  to <span v-if="((amortzHist.page * amortzHist.limit)>amortzHist.total)">{{amortzHist.total}}</span> <span v-else>{{amortzHist.page * amortzHist.limit}}</span>
                  of {{amortzHist.total}} entries
              </div>        
              </b-col>
              <b-col cols="3">            
                  <b-row class="ml-2 mt-2">
                    <span class="pt-1 pr-2">per page</span>
                    <b-form-select :options="[12, 24, 36, 48, 60]" :plain="true" v-model="amortzHist.limit"  size="sm" style="width:60px !important;"/>
                  </b-row>
              </b-col>
              <b-col cols="5">            
                <b-pagination
                  align="right"
                  :total-rows="amortzHist.total"
                  :per-page="amortzHist.limit"
                  v-model="amortzHist.page"
                ></b-pagination>
              </b-col>
            </b-row>

         </b-col>
      </b-row>
      <b-row class="justify-content-center mt-2">
          <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuAssetlocatShow" size="lg" :hide-footer="true" title="List of Location" :centered="true">
            <lku-assetlocat @click="onSelectLkuAssetlocat"></lku-assetlocat>
        </b-modal>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>

<style lang="scss">
    .table-wraper {
         width:100%;
         height:380px;
         overflow-x: auto;
         overflow-y: auto;
        border: 1px solid silver;
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 140px;
            }
        }
    }

</style>


<script>
import toastr from "mini-toastr";
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuCrew from "../lookup/lkuCrewlazzy";
import lkuAssetlocat from "../lookup/lkuAssetlocat";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
import fixedasset from '../../apis/fixedasset';
toastr.init();

export default {
  components: { Loading,myNumber, vDim, lkuCrew, lkuAssetlocat},
  mixins: [validationMixin],
  validations: {
    model: {
        asdatacq: { required },
        asdatuse: { required },
        asdesc: { required },
        matauang: { required },
        catgid: { required },
        deprmethod: { required },
        tarifDD: {required : (function() {
                if ((this.model.deprmethod || 0) == 1) {
                    return true;
                } else if ((this.model.tarifDD || 0)==0){
                    return false;
                } else return true;
            })},
        aspurcpri: { required, minValue:minValue(1) },
        origincost: { required, minValue:minValue(1) },
        totalakan: { required, minValue:minValue(1) },
        Nilaisusut: { required, minValue:minValue(1) },
        kurstrx: { required, minValue:minValue(0.0001) },
        lamathn: {required : (function() {
                if ((this.model.lamabln || 0) != 0) {
                    return true;
                } else if ((this.model.lamathn || 0)==0){
                    return false;
                } else return true;
            })},
        lamabln: {required : (function() {
                if ((this.model.lamathn || 0) != 0) {
                    return true;
                } else if ((this.model.lamabln || 0)==0){
                    return false;
                } else return true;
            })},
    },
  },   
  data() {
    return {
      saveEnabled: true,
      isLoading:false,
      lkuCrewData:{},
      lkuCrewShow:false,
      lkuAssetlocatShow:false,
      showDepreciation:false,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      model: {
          asdatacq: '',
          asdatuse: '',
          asdesc: '',
          matauang: this.$store.state.user.matauang,
          catgid: '',
          deprmethod: 1,
          aspurcpri: '',
          origincost: '',
          totalakan: '',
          Nilaisusut: '',
          kurstrx: 1,
          lamathn: '',
          lamabln: '',
          aspublic: 0,
          crewkey: '',
      },
      updateDimHdr:false,
      totalDb:0,
      totalCr:0,
      totalRow:0,
      currency:[],
      categories:[],
      uanguser:this.$store.state.user.matauang,
      lblExchRate:'Exchange Rate',
      amortzHist: {
        items: [],
        fields:[
          {
            key: "lineno",
            label: "No.",
            thStyle: "width:20px",
          },
          {
            key: "tgldeprec",
            label: "Scheduled",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "depamount",
            label: "Depreciated Amount",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "depaccum",
            label: "Accumulation Amount",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "tgl_gl",
            label: "Actual JV Date",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomorgl",
            label: "Actual JV Number",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ] ,
        page: 1,
        limit:12,
        total: 0,
        sortBy: 'tgldeprec',
        sortDesc: false
      },
    }
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    matauang(){
      return this.model.matauang;
    },
    kurstrx(){
      return this.model.kurstrx;
    },
    origincost(){
      return this.model.origincost;
    },
  },
  watch: {  
    matauang: function (newval) {
      if (newval === this.uanguser) this.model.kurstrx = 1;
    },
    kurstrx: function (newval) {
      this.model.totalakan = parseFloat(this.model.origincost) * parseFloat(newval || 1);
    },
    origincost: function (newval) {
      this.model.aspurcpri = parseFloat(this.model.kurstrx  || 1) * parseFloat(newval);
      this.model.totalakan = this.model.aspurcpri;
    }
  },

  created: async function (){
    //  const { user } = this.$store.state;
      this.lblExchRate=`Exch. Rate to ${this.uanguser}`;
      if (this.$route.params.asetkey)  {
          toastr.info('Loading Fixed Asset Detail, please wait')
          try {
            const [a,b,data] = await Promise.all([fixedasset.currency(),fixedasset.category(),fixedasset.detail(this.$route.params)]);
            this.currency = a;
            this.categories=b;
            // const data = await fixedasset.detail(this.$route.params);  
            const row = data[0][0];
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.updateDimHdr = !this.updateDimHdr;
            this.model.asdatacq = row.asdatacq ? moment(row.asdatacq).format('YYYY-MM-DD') : '';
            this.model.asdatuse = row.asdatuse ? moment(row.asdatuse).format('YYYY-MM-DD') : '';
            this.model.tglgaransi = row.tglgaransi ? moment(row.tglgaransi).format('YYYY-MM-DD') : '';
            this.model.tglAkhirDepr = row.tglAkhirDepr ? moment(row.tglAkhirDepr).format('YYYY-MM-DD') : '';
            this.model.asdatuseB4 = this.model.asdatuse 
            this.model.lamathnB4 = this.model.lamathn;
            this.model.lamablnB4 = this.model.lamabln;
            this.model.totalakanB4 = this.model.totalakan;
            this.model.deprmethodB4 = this.model.deprmethod;
            this.model.tarifDDB4 = this.model.tarifDD;

            this.amortzHist.items = data[1];
            this.amortzHist.total = this.amortzHist.items.length;

            this.$forceUpdate();
            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
            const [a,b,data] = await Promise.all([fixedasset.currency(),fixedasset.category()]);
            this.currency = a;
            this.categories=b;
      }
  },
  methods: {
    updateUser() {
      if (this.model.aspublic==1) {
         this.model.crewkey='';
         this.model.crewinfo='';
      }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    onSelectLkuCrew: async function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.model.crewkey = lkuData.selected.crewkey;
        this.model.crewnik = this.model.crewnik;
        this.model.jabatan = lkuData.selected.jabatan;
        this.model.departemen = this.model.departemen;
        this.lkuCrewShow=false;
    },
    onSelectLkuAssetlocat: async function (_selected) {
        this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
        this.model.aslocatkey = _selected.aslocatkey;
        this.model.kodelokasi = this.model.kodelokasi;
        this.model.namalokasi = _selected.namalokasi;
        this.lkuAssetlocatShow=false;
    },
    save: async function () {
        // console.log('Save Clicked');
        if (!this.saveEnabled) {
            return;
        }
        this.saveEnabled=false;
        if (this.invalidModel) {
                const invalidobj={};
                for (var key in this.$v.model) {
                  if (this.$v.model[key].$anyError) {
                    if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
                  }
                }        
                console.log('validation model: ', this.$v.model);
                console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;
        } else {
            try {
              this.isLoading=true;
              let data= {}
              for (var key in this.model) {
                  data[key] = this.model[key];
              }
              data.asdatacq = moment(this.model.asdatacq).format('YYYY-MM-DD');
              data.asdatuse = (this.model.asdatuse) ? moment(this.model.asdatuse).format('YYYY-MM-DD') : '';
              data.tglgaransi = (this.model.tglgaransi) ? moment(this.model.tglgaransi).format('YYYY-MM-DD') : '';
              data.tglAkhirDepr = (this.model.tglAkhirDepr) ? moment(this.model.tglAkhirDepr).format('YYYY-MM-DD')  : '';

              const hasil = await fixedasset.save(data);
                toastr.success(`Save Success, ${hasil.asetid}`, "Fixed Asset",10000);
                this.saveEnabled=true;
              this.isLoading=false;
              this.close();
            } catch (error) {
                this.saveEnabled=true;
                this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        }
    },
    update_monthly_amortisasi: function() {
      let lamaamortisasi = (parseFloat(this.model.lamathn || 0) * 12) + parseFloat(this.model.lamabln || 0);
      if (lamaamortisasi != 0) {
            this.model.Nilaisusut = parseFloat(this.model.totalakan) / lamaamortisasi;
            this.model.tglAkhirDepr = moment(this.model.asdatuse, 'YYYY-MM-DD').add(lamaamortisasi-1, 'M').format('YYYY-MM-DD');
      }
      this.$forceUpdate();
    },    
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'fixedasset.form')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'fixedasset.home'});
      }
    },    
  }
};
</script>
